import type { FigureVarDataDto } from "../types";

/**
 * Convert an object to an array of FigureVarDataDto
 *
 * @param obj - Object to convert
 * @returns Array of FigureVarDataDto
 */
export const objToFigureVarData = (obj: object): FigureVarDataDto[] =>
  Object.entries(obj).map(([varName, value]) => ({ varName, value: String(value) }));
